import { motion } from "framer-motion";

export default function PageHero({ title, subtitle, eyebrow }) {
  return (
    <section className="relative bg-royal text-white pt-20 pb-24 px-6 overflow-hidden" data-testid="page-hero">
      <div className="absolute inset-0 opacity-15"
        style={{ backgroundImage: "radial-gradient(circle at 20% 0%, #d4a622 0%, transparent 40%), radial-gradient(circle at 80% 100%, #1e40af 0%, transparent 50%)" }} />
      <div className="relative max-w-7xl mx-auto text-center">
        <motion.span initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
          className="inline-block bg-white/10 border border-gold/40 text-gold px-5 py-1.5 rounded-full text-xs font-bold tracking-[0.25em]">
          {eyebrow}
        </motion.span>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}
          className="font-serif-display text-5xl md:text-6xl font-bold mt-6">
          {title}
        </motion.h1>
        <div className="w-16 h-1 bg-gold mx-auto mt-5 rounded-full" />
        {subtitle && (
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-6 text-lg text-gray-200 max-w-2xl mx-auto leading-relaxed">
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
